<div>
  @for (num of this.items; track num) {
    <div>
      <p>{{ '• ' + num }}</p>
    </div>
  }
</div>
